import { useEffect } from 'react';
import { AppProviders } from '@/app/providers/AppProviders';
import { AppRoutes } from '@/app/routes';
import { useAppDispatch } from '@/app/store/hooks';
import { hydrateAuth } from '@/features/authentication';

/**
 * Side-effect only. Kicks off session restore from the stored refresh token;
 * ProtectedRoute waits on `hydrated` so nothing flash-redirects to /login.
 */
function Hydrator() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(hydrateAuth());
  }, [dispatch]);

  return null;
}

function App() {
  return (
    <AppProviders>
      <Hydrator />
      <AppRoutes />
    </AppProviders>
  );
}

export default App;
